/**
 * <summer-sale-countdown> custom element.
 *
 * Small product-page countdown pill, only rendered by the
 * summer-sale-countdown snippet on products tagged "summersale26".
 * Counts down to data-end; hides the numbers and shows the "ended"
 * message once the date passes.
 *
 * Accepts (data attributes):
 * - data-end: ISO 8601 date/time string
 */
(function () {
  if (customElements.get('summer-sale-countdown')) return;

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  class SummerSaleCountdown extends HTMLElement {
    connectedCallback() {
      this.endDate = new Date(this.dataset.end);

      this.unitsEl = this.querySelector('[data-units]');
      this.endedEl = this.querySelector('[data-ended]');
      this.daysEl = this.querySelector('[data-days]');
      this.hoursEl = this.querySelector('[data-hours]');
      this.minsEl = this.querySelector('[data-minutes]');
      this.secsEl = this.querySelector('[data-seconds]');

      if (isNaN(this.endDate.getTime())) {
        this.setAttribute('hidden', '');
        return;
      }

      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    tick() {
      var diff = this.endDate.getTime() - Date.now();

      if (diff <= 0) {
        clearInterval(this.interval);
        if (this.unitsEl) this.unitsEl.setAttribute('hidden', '');
        if (this.endedEl) this.endedEl.removeAttribute('hidden');
        return;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (this.daysEl) this.daysEl.textContent = pad(days);
      if (this.hoursEl) this.hoursEl.textContent = pad(hours);
      if (this.minsEl) this.minsEl.textContent = pad(minutes);
      if (this.secsEl) this.secsEl.textContent = pad(seconds);
    }
  }

  customElements.define('summer-sale-countdown', SummerSaleCountdown);
})();
